import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import AdminUserForm from "./AdminUserForm";
import { toast } from 'react-toastify';

const AdminEditUser = ({ id, children, onChange, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [form, setForm] = useState({});

    const loadData = () => {
        adminHttp
            .get('/users/' + id)
            .then(res => {
                setForm({
                    'first_name': res.data.first_name,
                    'last_name': res.data.last_name,
                    'email': res.data.email,
                    'phone': res.data.phone,
                    'password': '',
                    'company': res.data.company,
                });
            })
    };

    useEffect(loadData, []);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    if (!form.password) {
        delete form.password;
    }

    const handleSubmit = () => {
        toast.promise(
            adminHttp.put('/users/' + id, form),
            {
                pending: 'Saving user...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'User saved'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (
        <>
            <a {...rest} onClick={handleShow}>{children}</a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit User #{id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving user!"}
                        </div>
                    )}

                    <AdminUserForm values={form} errors={error?.errors} onChange={f => setForm(f)} />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AdminEditUser;
